import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import image10 from '../assets/newHeader/image23.jpg';
import introImg from '../assets/newHeader/workforce1.jpg';
import hiwImg from '../assets/public-site/hiwImg.png';
import image16 from '../assets/public-site/img16.jpeg';
import whyThisImg from '../assets/public-site/whyThisImg.png';
import wygImg1 from '../assets/public-site/wygImg1.svg';
import wygImg2 from '../assets/public-site/wygImg2.svg';
import wygImg3 from '../assets/public-site/wygImg3.svg';
import wygImg4 from '../assets/public-site/wygImg4.svg';
import { TestimonialCarousel } from '../components/common/TestimonialCarousel';
import { VovationalPage } from '../components/common/VovationalPage';
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const WorkForce: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const testimonialData = [
    {
      name: 'Edwin Rivera',
      location: 'Managing Partner,CG1 Solutions',
      title: 'Faster Hires, Better Matches',
      text: 'Vero helped us reduce time-to-hire by over 60% while improving placement fit. Their team gets it.',
      image: image16,
      collanColor: 'text-[#4A5FF7]',
    },
  ];
  return (
    <div>
      {/* header */}
      <NewNavbar />

      {/* hero section */}
      <section
        className="
    relative w-full h-screen bg-cover bg-center bg-no-repeat 
    before:absolute before:inset-0 before:z-10 
    lg:before:hidden
    before:bg-gradient-to-r before:from-black before:to-transparent
  "
        style={{
          backgroundImage: `
            linear-gradient(180deg, rgba(0, 0, 0, 0) 47.64%, #000000 100%),
            url(${introImg})
          `,
        }}
      >
        <div className="relative z-20 flex items-end justify-center h-full container mx-auto px-6 pb-10 text-white text-center">
          <div className="w-full space-y-6">
            <h1 className="text-4xl sm:text-5xl font-normal">
              From intake to impact-track
              <span className="text-[#FFC90D] font-bold"> what actually matters. </span>
            </h1>
            <p className="mt-2 text-lg sm:text-xl !leading-loose font-semibold">
              Vero helps workforce boards, nonprofits, and public agencies place talent into jobs
              and prove long-term success. Whether you're matching jobseekers to employers or
              supporting career transitions, Vero makes your outcomes visible, your data actionable,
              and your placements smarter.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-primary !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a Strategy Session <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* Why This Still Hurts Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal mb-4 !leading-tight">
                Why This Still
                <span className="font-bold text-primary-500"> Hurts</span>
              </h2>

              <p className="text-lg font-normal sm:text-lg md:text-xl !leading-loose">
                You’ve invested in training, coaching, and support—but job placement is still a
                challenge.
              </p>

              <p className="text-base sm:text-lg md:text-xl font-semibold leading-relaxed mt-4">
                Here’s why:
              </p>

              <ul className="list-disc pl-5 text-base font-normal sm:text-lg md:text-xl !leading-loose mt-2">
                <li>Employers can’t see beyond resumes and credentials</li>
                <li>Your staff is overwhelmed manually trying to match candidates</li>
                <li>You lack clear data on who’s job-ready and what success looks like</li>
                <li>Partners want outcomes, but your tools weren’t built for placement</li>
                <li>Good talent keeps getting overlooked—again and again</li>
              </ul>

              <p className="text-base font-normal sm:text-lg md:text-xl !leading-loose mt-4 mb-6">
                Vero connects your mission to real job outcomes. No extra bandwidth required.
                Improve placement with tools built for workforce teams.
              </p>
              <a
                className="btn btn-secondary !whitespace-normal !py-6 !px-8"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
              >
                Track who’s thriving—not just who’s completing <ExportedIcon />
              </a>
            </div>

            {/* Right Image */}
            <div className="relative w-full">
              <img
                src={whyThisImg}
                alt="Team Collaboration"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="pb-16">
        <div className="container">
          {/* <p className="text-2xl text-center mb-4">Who We Support</p> */}
          <h2 className="text-4xl sm:text-5xl font-normal md:text-6xl text-center mb-8">
            What You
            <span className="text-primary-500  font-bold"> Get</span>
          </h2>
          <p className="text-xl md:text-3xl !leading-relaxed text-center mb-8">
            Workforce outcomes shouldn’t stop at job placement. Vero tracks retention, reveals risk
            patterns, and helps teams improve what matters most: long-term mobility.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Employer Card 1 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-48">
                <img
                  src={wygImg1}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium">Recommend better jobs + industries</h3>
              <p className="text-center !leading-loose">
                Suggest high-fit roles based on real-time insights-not guesswork or surface-level
                skills.
              </p>
            </div>
            {/* Employer Card 2 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-green-200 flex flex-col items-center gap-3 text-center">
              <div className="h-48">
                <img
                  src={wygImg2}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium">Match participant skills to employer needs</h3>
              <p className="  text-center !leading-loose">
                Bridge the gap between programs and hiring pipelines with AI-backed intelligence.
              </p>
            </div>
            {/* Employer Card 3 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-cream-200 flex flex-col items-center gap-3 text-center">
              <div className="h-48">
                <img
                  src={wygImg3}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium">Track retention and upskilling outcomes</h3>
              <p className="  text-center !leading-loose">
                Prove long-term impact with data on job success, career progression, and retention.
              </p>
            </div>
            {/* Employer Card 4 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-secondary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-48">
                <img
                  src={wygImg4}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium ">
                Plug into your systems <br /> fast
              </h3>
              <p className="  text-center !leading-loose">
                Vero integrates with your case management tools and is up and running in under 30
                days.
              </p>
            </div>
          </div>
          <p className="text-xl md:text-3xl !leading-relaxed text-center mt-8">
            Vero isn’t just a placement tool—it’s your decision engine for long-term impact. <br />{' '}
            From retention risks to promotion pathways, we help you surface what’s working and where
            to improve
          </p>
          {/* Button Section */}
        </div>
      </section>
      <section className=" bg-primary-200  py-8">
        <div className="container mx-auto flex flex-col sm:flex-row gap-4 items-center justify-between  text-center md:text-left">
          <p className="text-3xl font-bold">Want to see how this works in your intake process?</p>
          <a
            className="btn btn-secondary !py-6 !px-12"
            href="https://meetings.hubspot.com/chrissybil/vero-learning"
            target="_blank"
          >
            Book here <ExportedIcon />
          </a>
        </div>
      </section>

      {/* How It Works Section */}
      <section className=" py-16">
        <div className="container mx-auto text-center">
          <p className="text-2xl">How It Works</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl mt-2 mb-8 leading-snug">
            One platform. Three steps.
            <span className="text-primary-500 font-bold m-2">Smarter decisions.</span>
          </h2>
          <p className="text-3xl">Built for scale. Designed for privacy. Ready to integrate.</p>
        </div>

        <div className="container mx-auto mt-10 grid grid-cols-1 lg:grid-cols-2 items-center gap-10">
          {/* Left Column - Text */}
          <div className="col-span-1 text-center md:text-left space-y-6">
            {[
              {
                title: 'Surface Talent Potential',
                desc: `Start with your existing intake—but make it smarter. Vero layers in skill signals,
          real-world experience, and motivational assessments to uncover overlooked strengths.
          Our unique pre-employment flow includes evaluations and coachable moments—so you're
          not just screening, you're activating growth.`,
              },
              {
                title: 'Match + Recommend',
                desc: `We identify roles where each participant is most likely to thrive—based on actual
          hiring, retention, and progression data. Vero accounts for nontraditional
          backgrounds, and elevates candidates on trajectory, not just credentials.`,
              },
              {
                title: 'Place + Improve',
                desc: `After placement, Vero tracks retention, analyzes risks, and delivers prescriptive
          guidance. Think :`,
                list: [
                  'Retrain for entry-level IT in 60 days.',
                  'Fast-track to certified logistics roles.',
                  'Promote to team lead in Q2.',
                ],
              },
              // {
              //   desc: `Show funders and public partners not just who got hired—but who succeeded. Vero helps workforce programs align with outcomes-based funding and next-gen workforce policy priorities.`,
              // },
            ].map((item, index) => (
              <div
                key={index}
                className="border-dashed border border-purple-200 rounded-[32px] p-7"
              >
                <h3 className="text-3xl mb-2 font-bold">{item.title}</h3>
                <p className="text-gray-700 text-xl  leading-relaxed">{item.desc}</p>
                {item.list && (
                  <ul className="text-gray-700 mt-4 text-xl list-disc list-inside">
                    {item.list.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
            <div className="border-dashed border border-purple-200 rounded-[32px] p-7">
              <p className="text-gray-800 text-2xl leading-relaxed">
                Show funders and public partners not just who got hired—but who succeeded. Vero
                helps workforce programs align with outcomes-based funding and next-gen workforce
                policy priorities.
              </p>
            </div>
          </div>

          {/* Right Column - Images */}
          <div className="col-span-1 relative w-full max-w-xl">
            <img
              src={hiwImg}
              alt="Team Collaboration"
              className="w-full h-auto object-cover rounded-xl"
            />
          </div>
        </div>
      </section>

      <section className="bg-primary-200 py-8">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center md:text-left">
            Fast implementation. Built for long-term change
          </h2>

          <a
            href="https://meetings.hubspot.com/chrissybil/vero-learning"
            className="btn btn-secondary !px-12 !py-6 hover:underline"
            target="_blank"
          >
            Book a live walkthrough <ExportedIcon />
          </a>
        </div>
      </section>

      {/* Who We Serve Best Section */}
      <section className="py-16">
        <div className="container max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-6xl font-normal mb-4">
            Who We <span className="text-primary-500 font-bold">Serve Best</span>
            <br className="hidden md:block" />
          </h2>

          <p className="text-3xl mb-8">Best fit for</p>

          <p className="text-2xl !leading-loose">
            Workforce development leaders, program directors, municipal workforce teams, and
            nonprofits that place people into real jobs. We’re a fit if your team is focused on job
            success—not just program completion—and needs a platform that adapts to your system.
          </p>

          <h3 className="text-2xl font-semibold mb-6 mt-8">
            Get started in under 30 days. Scale into lasting transformation
          </h3>

          <a
            href="/login"
            className="btn btn-secondary !px-12 !py-6"
            target="_blank"
            rel="noopener noreferrer"
          >
            Start Now <OpenInNewIcon style={{ fontSize: 20 }} />
          </a>
        </div>
      </section>

      <section className="bg-primary-200 py-16">
        <div className="container">
          <h2 className="text-3xl lg:text-6xl font-normal mb-4 text-center">
            What Our <span className="text-primary-500 font-bold">Partners </span> Say
          </h2>{' '}
          <TestimonialCarousel testimonials={testimonialData} />;
        </div>
        <div className="container flex flex-row items-end  justify-end gap-4 mt-54">
          <h2 className="text-2xl md:text-3xl font-bold text-center md:text-left mb-5">
            Let’s prove outcomes together
          </h2>

          <a
            href="https://meetings.hubspot.com/chrissybil/vero-learning"
            className="btn btn-secondary w-fit !px-12 !py-6 hover:underline !whitespace-normal md:whitespace-nowrap"
            target="_blank"
          >
            See your potential metrics <ExportedIcon />
          </a>
        </div>
      </section>

      {/* containe 10 */}
      <VovationalPage />

      <section className="py-16">
        <div className="container">
          <h2 className="text-2xl md:text-4xl text-center !leading-normal">
            Join 35,000+ users already improving hiring outcomes with Vero’s predictive
            intelligence.
          </h2>
        </div>
      </section>

      {/* container 13 */}
      <ConnectForm
        text="Schedule a walkthrough and see how Vero fits your workforce funding model."
        header="Want to plug Vero into your workforce ecosystem?"
        buttonText="Book a Strategy Session"
      />
      <NewFooter />
    </div>
  );
};
